export default "__VITE_ASSET__BhYr4Er$__"